import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BasketReviewMessage } from '@epicuro-next/data/baskets-dto';
import { AccountReviewer } from 'graphql-api/gql-api-interfaces';

import { BASKET_API_TOKEN } from '../tokens';

@Injectable()
export class BasketReviewService {
  private readonly httpClient = inject(HttpClient);
  private readonly url = inject(BASKET_API_TOKEN);

  public submitForReview(
    basketId: string,
    reviewerId: string,
    reviewMessagePayload: BasketReviewMessage,
  ) {
    return this.httpClient.post(
      `${this.url}/${basketId}/submitforreview?reviserUserId=${reviewerId
        .split('+')
        .join('%2B')}`,
      {
        ...reviewMessagePayload,
        useUrlResolver: true,
      },
    );
  }

  public rejectBasket(
    basketId: string,
    reviewMessagePayload: BasketReviewMessage,
  ) {
    return this.httpClient.post(`${this.url}/${basketId}/reject`, {
      ...reviewMessagePayload,
      useUrlResolver: true,
    });
  }

  public getAccountBasketReviewers(basketId: string) {
    return this.httpClient.get<AccountReviewer[]>(
      `${this.url}/${basketId}/reviewers`,
    );
  }

  public canReview(basketId: string) {
    return this.httpClient.get<boolean>(`${this.url}/${basketId}/canreview`);
  }
}
